import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

interface IconWithTooltipProps {
    iconClass: string;
    tooltipKey: string;
    ariaLabel: string;
}

/** A rioglyph icon wrapped in a tooltip, mirroring WFE's StateIcon/ItemIcon. */
export const IconWithTooltip = ({ iconClass, tooltipKey, ariaLabel }: IconWithTooltipProps) => (
    <OverlayTrigger
        placement={Tooltip.TOP}
        overlay={
            <Tooltip width="auto">
                <FormattedMessage id={tooltipKey} />
            </Tooltip>
        }
    >
        <span className={iconClass} role="img" aria-label={ariaLabel} />
    </OverlayTrigger>
);
